import request from "./axios";

export function getAction(url,parameter){
  return request({
    url: url,
    method: "get",
    params: parameter
  })
}

export function postAction(url,parameter){
  return request({
    url: url,
    method: "post",
    data: parameter
  })
}

/**
 * 登录
 */
export function login(username, password) {
  return request({
    url: "/api/sys/mLogin",
    method: "post",
    data: {
      username,
      password
    }
  });
}

export function getSmsCode(mobile){
  return request({
    url: "/api/sys/sms",
    method: "post",
    data:{
      mobile: mobile,
      smsmode: "1"
    }
  })
}

export function checkOnlyUser(username){
  return request({
    url: '/api/sys/user/checkOnlyUser?username='+username,
    method: 'get'
  })
}

export function register(username, password, phone, smscode){
  return request({
    url: "/api/sys/user/register",
    method: "post",
    data:{
      phone, username, password,smscode
    }
  })
}

export function registerAndBindWechat(phone,smscode){
  return request({
    url: "/api/sys/user/registerAndBindWechat",
    method: "post",
    data:{
      phone,smscode
    }
  })
}

//将用户名发送到手机号
export function getUsernameByPhone(phone){
  return request({
    url: "/api/sys/getUsernameByPhone?phone="+phone,
    method: "get"
  })
}

//重置密码
export function resetPassword(username, password,smscode, phone){
  return request({
    url: "/api/sys/user/passwordChange",
    method: "get",
    params: {
      username, password, smscode, phone
    }
  })
}

/**
 * 登出
 */
export function logout() {
  return request({
    url: "/api/sys/logout",
    method: "post"
  });
}

export function getTokenBySession(){
  return request({
    url: "/api/sys/getTokenBySession",
    method: "get"
  })
}

// 获取个人信息s
export function getUserInfo() {
  return request({
    url: "/api/teaching/user/detail",
    method: "get"
  });
}

/**
 * 修改个人信息
 */
export function updateUserInfo(data) {
  return request({
    url: "/api/teaching/user/edit",
    method: "put",
    data
  });
}

/**
 * 我的全部课程列表
 */
export function getMineCourse(data) {
  return request({
    url: "/api/teaching/teachingCourse/mineCourse",
    method: "put",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js